/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} WelcomeInputs */

const th_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยินดีต้อนรับสู่ Remy Sport`)
};

const en_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome to Remy Sport`)
};

const ja_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy Sport へようこそ`)
};

const zh_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎来到 Remy Sport`)
};

const es_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te damos la bienvenida a Remy Sport`)
};

const pt_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boas-vindas ao Remy Sport`)
};

const id_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selamat datang di Remy Sport`)
};

const fr_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenue sur Remy Sport`)
};

const tl_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maligayang pagdating sa Remy Sport`)
};

const vi_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chào mừng tới Remy Sport`)
};

const ko_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy Sport에 오신 것을 환영합니다`)
};

const de_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen bei Remy Sport`)
};

const ru_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добро пожаловать в Remy Sport`)
};

const tr_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy Sport'a hoş geldiniz`)
};

const it_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benvenuto su Remy Sport`)
};

const pl_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Witamy w Remy Sport`)
};

const uk_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ласкаво просимо до Remy Sport`)
};

const hi_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy Sport में आपका स्वागत है`)
};

const ar_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحبًا بك في Remy Sport`)
};

const ms_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selamat datang ke Remy Sport`)
};

const bn_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy Sport-এ স্বাগতম`)
};

const zh_tw2_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`歡迎來到 Remy Sport`)
};

const zh_hk2_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`歡迎來到 Remy Sport`)
};

const ur_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remy Sport میں خوش آمدید`)
};

const fa_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`به Remy Sport خوش آمدید`)
};

const sw_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karibu Remy Sport`)
};

const nl_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welkom bij Remy Sport`)
};

/**
* | output |
* | --- |
* | "Welcome to Remy Sport" |
*
* @param {WelcomeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const welcome = /** @type {((inputs?: WelcomeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WelcomeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_welcome(inputs)
	if (locale === "ja") return ja_welcome(inputs)
	if (locale === "zh") return zh_welcome(inputs)
	if (locale === "es") return es_welcome(inputs)
	if (locale === "pt") return pt_welcome(inputs)
	if (locale === "id") return id_welcome(inputs)
	if (locale === "fr") return fr_welcome(inputs)
	if (locale === "tl") return tl_welcome(inputs)
	if (locale === "vi") return vi_welcome(inputs)
	if (locale === "ko") return ko_welcome(inputs)
	if (locale === "de") return de_welcome(inputs)
	if (locale === "ru") return ru_welcome(inputs)
	if (locale === "tr") return tr_welcome(inputs)
	if (locale === "it") return it_welcome(inputs)
	if (locale === "pl") return pl_welcome(inputs)
	if (locale === "uk") return uk_welcome(inputs)
	if (locale === "hi") return hi_welcome(inputs)
	if (locale === "ar") return ar_welcome(inputs)
	if (locale === "ms") return ms_welcome(inputs)
	if (locale === "bn") return bn_welcome(inputs)
	if (locale === "zh-TW") return zh_tw2_welcome(inputs)
	if (locale === "zh-HK") return zh_hk2_welcome(inputs)
	if (locale === "ur") return ur_welcome(inputs)
	if (locale === "fa") return fa_welcome(inputs)
	if (locale === "sw") return sw_welcome(inputs)
	if (locale === "nl") return nl_welcome(inputs)
	return en_welcome(inputs)
});